import React from 'react';
import Navbar from './Nav';
import Footer from './Footer';
import Sidebar from './Sidebar';
import './App.css';


import { Link } from "react-router-dom";


const About = () => {
    return (
      <div className="overflow-x-hidden text-white background elegant ">
        <Navbar />
        <div className="w-full container px-5 block lg:flex py-24 mx-auto  justify-between">
          <div className="w-full lg:w-1/3 mx-2">
            <Sidebar />
          </div>
          <div
            className="w-full my-10 lg:my-0 lg:w-2/3 mx-auto"
            data-aos="fade-right"
            data-aos-duration="1500"
          >
            <div className="md:bg-zinc-900 rounded-xl  container px-5 py-10">
              <p className="text-sm">
                <span className="text-lime-500 text-5xl Riesling  font-bold ">
                  About me
                </span>
                <br />
                <br />
                I am currently a student at the Institute of Science and
                Technology, Dhaka, pursuing my passion for web development with
                a focus on the MERN stack. My journey in this field began when I
                completed two comprehensive courses on MERN development—one
                through DIPTI and the other on an online platform, Ostad. These
                courses provided me with a strong foundation in the technologies
                that power modern web applications.nimalist and brutalist design
                principles. <br /> <br />
                In addition to my academic pursuits, I’ve had the opportunity to
                work on several freelancing projects through Fiverr and Upwork,
                where I developed practical skills by creating dynamic websites
                and applications for clients. These experiences have helped me
                improve my problem-solving abilities and my understanding of
                client needs, while also allowing me to work with technologies
                like React, Node, Express, MongoDB, and more. <br />
                My proficiency in C and C++ has also contributed to my growth as
                a developer, expanding my understanding of programming
                principles and logic. I'm comfortable working with both frontend
                and backend technologies and am always looking for new
                challenges to sharpen my skills. <br />
                <br />
                I’m excited about building web applications that make a
                difference and solving real-world problems through code. As a
                developer, I’m committed to continuous learning and growth,
                eager to stay up to date with the latest trends in technology.
                Whether working independently or as part of a team, I thrive on
                creating solutions that not only meet but exceed expectations.
                <br />
              </p>
            </div>
          </div>
        </div>
        <div className=" lg:flex rounded-xl  px-5 container justify-center mx-auto py-24">
          <div
            className="lg:w-1/2 md:w-2/3 w-full bg-gradient-to-r from-gray-500 to-lime-800   py-8 rounded-xl lg:mr-3 container mx-auto"
            data-aos="fade-right"
            data-aos-duration="1500"
          >
            <p className="text-sm px-5 text-zinc-300">
              <span className="text-zinc-300 md:text-5xl text-3xl Riesling  font-bold ">
                {" "}
                Experience
              </span>{" "}
              <br />
              <br />
              <br />
              - Experience in Mern Stack Development
              <br />
              <br />
              - Experience with Upwork and FIVERR. <br />
              <br />- experience with Reactjs,JavaScript,Nodejs,
              ExpressJs,MongoDB,C,C++, Git & GitHub for version controll,Zustand
              and React-Redux For State Management
            </p>
          </div>
          <div
            className="py-5 rounded-xl lg:ml-2 my-10 lg:my-0   mx-auto container lg:w-1/2 md:w-2/3 w-full bg-gradient-to-r from-gray-500 to-lime-800  text-zinc-300 text-right px-4"
            data-aos="fade-left"
            data-aos-duration="1500"
          >
            <span className="text-zinc-300 md:text-5xl text-3xl Riesling  font-bold ">
              {" "}
              Education
            </span>{" "}
            <br />
            <br />
            <code>2022 - Present</code> <br />
            Learnings on Web Application development <br />
            Programming Hero
            <br />
            <br />
            <code>2023 - current</code> <br />
            Bachelor of Computer Science (BSC) <br />
            Institute of Science and Technology, Bangladesh
          </div>
        </div>

        <Footer />
      </div>
    );
};

export default About;